exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-details-academic {\n  position: absolute;\n  margin-left: 12rem;\n  z-index: 2;\n}\n.academic-details {\n  font-weight: 700;\n  font-size: 0.7rem;\n}\n.move-index {\n  font-weight: 700;\n  font-size: 0.7rem;\n  position: absolute;\n  color: #626262 !important;\n}\n.move-index-left {\n  top: 0;\n  left: 0;\n}\n.move-index-right {\n  top: 0;\n  right: 0;\n}  \n", ""]);

// exports
